import styled from "@emotion/styled";
import { Colors, Fonts } from "@snapchat/snap-design-system";
import { Flexbox } from "../../core/components";

export const LensSourceTypeLabel = styled.div`
    margin: 12px 0 20px;
    ${Fonts.Heading.H600}
    color: ${Colors.Black.V50};
`;

export const LensSourceName = styled.div`
    ${Fonts.Heading.H700}
    color: ${Colors.Black.V150};
`;

export const LensSourceInformation = styled(Flexbox)`
    padding: 12px 24px;
`;
